'use client';

import useOnWindowFocus from '@/hooks/useWindowFocus';
import { useEffect, useState } from 'react';
import { cookieStorage } from '@/services/cookie';

const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const { isWindowFocused } = useOnWindowFocus();

  const getIsAdmin = async () => {
    const { data } = await cookieStorage.get('is-admin-user');
    setIsAdmin(!!data);
  };

  useEffect(() => {
    if (isWindowFocused) {
      getIsAdmin();
    }
  }, [isWindowFocused]);

  return { isAdmin };
};

export default useIsAdmin;
